/* eslint-disable guard-for-in */
import { ESizeType } from '../types';
/** @description Вычисляет ширины элементов в зависимости от настроек карусели и ширины контейнера
 * @param {number} containerWidth ширины контейнера карусели в пикселях
 * @param {IElementsWidth} elementsWidth настройки ширин элементов
 * @param {number} slidesToShow число одновременно отображаемых слайдов на экране
 * @return {TCalculatedWidth}
 */

export function calculateWidth(containerWidth, elementsWidth, slidesToShow) {
  //Суммарное значение ширины всех элементов, изначально заданных в пикселях
  var pixelWidth = 0; //Итоговые ширины всех элементов переведенные в пиксели

  var calculatedWidth = {
    container: containerWidth,
    content: 0,
    leftEar: 0,
    rightEar: 0,
    gap: 0,
    slide: 0
  }; //Получение ширин, заданных в пикселях

  for (var key in elementsWidth) {
    var elem = elementsWidth[key];

    if (elem.type === ESizeType.PIXEL) {
      pixelWidth += elem.width;
      calculatedWidth[key] = elem.width;
    }
  } //На экране два gap слева и справа от текущего слайда, поэтому добавляем еще один


  pixelWidth += calculatedWidth.gap;
  var remainWidth = containerWidth - pixelWidth; //Вычисление ширин, заданных в процентах от оставшейся ширины контейнера

  for (var _key in elementsWidth) {
    var _elem = elementsWidth[_key];

    if (_elem.type === ESizeType.PERCENT) {
      calculatedWidth[_key] = _elem.width / 100 * remainWidth;
    }
  }

  calculatedWidth.slide = (calculatedWidth.content - calculatedWidth.gap * (slidesToShow - 1)) / slidesToShow;
  return calculatedWidth;
}
/** @description Вычисляет ширины элементов для SSR рендеринга
 * @param {IElementsWidth} elementsWidth настройки ширин элементов
 * @param {number} slidesToShow число одновременно отображаемых слайдов на экране
 * @return {TCalculatedWidth}
 */

export function calculateWidthSSR(elementsWidth, slidesToShow) {
  //Суммарное значение ширины всех элементов, изначально заданных в пикселях
  var pixelWidth = 0; //Итоговые ширины всех элементов переведенные в пиксели

  var calculatedWidthSSR = {
    container: '100%',
    content: '0',
    leftEar: '0',
    rightEar: '0',
    gap: '0',
    slide: '0'
  }; //Получение ширин, заданных в пикселях

  for (var key in elementsWidth) {
    var elem = elementsWidth[key];

    if (elem.type === ESizeType.PIXEL) {
      pixelWidth += elem.width;
      calculatedWidthSSR[key] = "".concat(elem.width, "px");
    }
  } //На экране два gap слева и справа от текущего слайда, поэтому добавляем еще один


  pixelWidth += parseInt(calculatedWidthSSR.gap, 10);
  var remainWidth = "(100% - ".concat(pixelWidth, "px)"); //Вычисление ширин, заданных в процентах от оставшейся ширины контейнера

  for (var _key2 in elementsWidth) {
    var _elem2 = elementsWidth[_key2];

    if (_elem2.type === ESizeType.PERCENT) {
      calculatedWidthSSR[_key2] = "".concat(_elem2.width / 100, " * ").concat(remainWidth);
    }
  }

  calculatedWidthSSR.slide = "(".concat(calculatedWidthSSR.content, " - (").concat(calculatedWidthSSR.gap, " * ").concat(slidesToShow - 1, ")) / ").concat(slidesToShow);
  return calculatedWidthSSR;
}